export const TableViewIcon = () => {
  return (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_11915_43273)">
        <path d="M34.0417 12.5417H16.125C14.1542 12.5417 12.5417 14.1542 12.5417 16.125V34.0417C12.5417 36.0125 14.1542 37.625 16.125 37.625H34.0417C36.0125 37.625 37.625 36.0125 37.625 34.0417V16.125C37.625 14.1542 36.0125 12.5417 34.0417 12.5417ZM34.0417 16.125V19.7083H16.125V16.125H34.0417ZM23.2917 26.875V23.2917H26.875V26.875H23.2917ZM26.875 30.4583V34.0417H23.2917V30.4583H26.875ZM19.7083 26.875H16.125V23.2917H19.7083V26.875ZM30.4583 23.2917H34.0417V26.875H30.4583V23.2917ZM16.125 30.4583H19.7083V34.0417H16.125V30.4583ZM30.4583 34.0417V30.4583H34.0417V34.0417H30.4583ZM10.75 30.4583H8.95833C6.9875 30.4583 5.375 28.8458 5.375 26.875V8.95833C5.375 6.9875 6.9875 5.375 8.95833 5.375H26.875C28.8458 5.375 30.4583 6.9875 30.4583 8.95833V10.75H26.875V8.95833H8.95833V26.875H10.75V30.4583Z" fill="#2E7D32"/>
      </g>
      <defs>
        <clipPath id="clip0_11915_43273">
          <rect width="43" height="43" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}